import React from 'react';
import {
    EditOutlined,
    DeleteOutlined,
    ExclamationCircleOutlined
} from '@ant-design/icons';
import { Space, Button, Modal } from 'antd';
import { Link } from 'react-router-dom';
import { removeProperties } from '../../api';

export const property_column = [
    {
        title: 'Property Name',
        key: 'property_name',
        dataIndex: 'property_name',
        render: (text) => <p style={{ textTransform: 'capitalize' }}>{text}</p>
    },
    {
        title: 'Property Type',
        key: 'property_type',
        dataIndex: 'property_type'
    },
    {
        title: 'Price',
        key: 'price',
        dataIndex: 'price'
    },
    {
        title: 'Locality',
        key: 'locality',
        dataIndex: 'locality',
        render: (text) => <p style={{ textTransform: 'capitalize' }}>{text}</p>
    },
    {
        title: 'City',
        key: 'city',
        dataIndex: 'city'
    },
    {
        title: 'Action',
        key: 'action',
        render: (props) => {
            const { slug, edit_url } = props;

            function showPromiseConfirm() {
                Modal.confirm({
                  title: 'Do you want to delete property?',
                  icon: <ExclamationCircleOutlined />,
                  content: `This will delete the property ${props.property_name}`,
                  onOk() {
                    return removeProperties([props._id]);
                  },
                  onCancel() {},
                });
              }

            return (
                <Space>
                    <Link to={location => ({ ...location, pathname: edit_url , search: `ref=${slug}`})}>
                        <Button 
                            icon={<EditOutlined />}
                            type="primary" 
                            stlye={{ width: '128px'}}
                        >
                            Edit
                        </Button>
                    </Link>
                    <Button 
                        type="ghost" 
                        danger
                        icon={<DeleteOutlined />}
                        onClick={showPromiseConfirm}
                    >
                        Delete
                    </Button>
                </Space>
            )
        }
    }
];
